import { Injectable } from '@angular/core';
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor,
	HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SpinnerService } from './spinner.service';
import { AlertService } from './alert.service';
import { ErrorInfo } from '../models/errorIntercept/errorModel';
import { PRESERVE_HTTP_ERROR } from './http-error-context';
import { isImportacionRequest } from '../config/importacion.config';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	constructor(
		private spinnerService: SpinnerService,
		private alert: AlertService
	) {}

	intercept(
		request: HttpRequest<ErrorInfo>,
		next: HttpHandler
	): Observable<HttpEvent<ErrorInfo>> {
		return next.handle(request).pipe(
			catchError((err: HttpErrorResponse) => {
				if (
					request.context.get(PRESERVE_HTTP_ERROR) ||
					isImportacionRequest(request.url)
				) {
					throw err;
				}
				const apiError = err?.error?.error;
				const errorInfo: ErrorInfo = {
					details: apiError?.details || 'Error desconocido',
					errorCode: apiError?.errorCode,
					propertyName: apiError?.propertyName,
					errorMessage: apiError?.errorMessage || 'Error desconocido',
					attemptedValue: apiError?.attemptedValue,
					errorInfo: apiError?.errorInfo
				};
				this.alert.datosError = errorInfo;
				const errorMsg = '';
				this.spinnerService.hide();
				throw new Error(errorMsg);
			})
		);
	}
}
